<template>
	<div v-if="show" :class="slideInClass">
		<header :class="{'titled': hasTitle}">
			<div v-if="hasTitle">
				<h4 v-html="title"/>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="close(false)">
					<Icon icon="close"/>
				</a>
			</div>
			<JonInfo v-if="jonInfo">
				<template #message>
					<div v-if="jonInfo === jonInfos.botCollege">
						Gib bitte deine abgeschlossene <b>Hochschulausbildung</b> ein.
						<br/><br/>
						Solltest du mehrere haben, dann gib die für dich wichtigste ein. Später kannst du noch
						weitere eingeben.
					</div>
					<div v-if="jonInfo === jonInfos.botHighSchool">
						Gib bitte deine abgeschlossene <b>Schulausbildung</b> ein.
						<br/><br/>
						Solltest du mehrere haben, dann gib die für dich wichtigste ein. Später kannst du noch
						weitere eingeben.
					</div>
				</template>
			</JonInfo>
		</header>
		<main class="scrollbar-check">
			<Edit
				v-model="education"
				:meta="meta"
				:with-school-type-selection="withSchoolTypeSelection"
				:with-details="withDetails"
			/>
		</main>
		<footer>
			<Button
				:text="education ? 'Ausbildung speichern' : 'Ausbildung hinzufügen'"
				:disabled="!education"
				icon="checkmark"
				@click="educationSaved"
			/>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Edit from "./Edit"
import Button from "@/vue/common/Button";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/application/education/fan";
import JonInfo from "@/vue/common/JonInfo.vue";
import {isEmptyOrNull} from "@/helper/String";
import {isDefined} from "@/helper/Value";

export const JON_INFO__BOT_COLLEGE = 'bot-college';
export const JON_INFO__BOT_HIGH_SCHOOL = 'bot-high-school';
export default {

	components: {
		JonInfo,
		Button,
		Icon,
		Edit,
	},

	computed: {
		...mapState('meta', ['meta']),
		...mapState('application/education/fan', [
			'show',
			'title',
			'jonInfo',
			'withSchoolTypeSelection',
			'withDetails'
		]),
		...mapState('layout', ['fanLevelClasses']),
		hasTitle ()
		{
			return isDefined(this.title) && !isEmptyOrNull(this.title);
		},
		jonInfos ()
		{
			return {
				botCollege: JON_INFO__BOT_COLLEGE,
				botHighSchool: JON_INFO__BOT_HIGH_SCHOOL
			};
		},
		education: {
			get ()
			{
				return this.$store.state.application.education.fan.education;
			},

			set (value)
			{
				this.setEducation(value);
			}
		},
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['application-education-fan']
			})
		}
	},

	methods: {
		...mapActions('application/education/fan', {
			closeFan: 'close'
		}),
		...mapMutations('application/education/fan', [
			'setEducation'
		]),
		educationSaved ()
		{
			this.close(true);
		},
		close (confirm)
		{
			this.closeFan({
				confirm
			});
		}
	}
}
</script>
